<app-modal [(show)]="show" heading="{{ heading }}" (showChange)="closeModal()">
  <div class="text-section" *ngIf="content">
    <app-markdown [(markdown)]="content" [readonly]="true"></app-markdown>
  </div>
</app-modal>
